module.exports = __webpack_public_path__ + "img/Fornt door.d0cfb001.jpg";